import { ChapterEnum } from '@gql/graphql';

import type React from 'react';

export const CHAPTER_RECORDS: Record<ChapterEnum.Chapter1_7 | ChapterEnum.Chapter8 | ChapterEnum.Chapter9, string> = {
    CHAPTER1_7: 'Глава 1-7',
    CHAPTER8: 'Глава 8',
    CHAPTER9: 'Глава 9',
};

/*
    Способ создания лимитированных.
 */
export const enum CreatingTypes {
    /*
    Вручную
     */
    MANUAL = 'MANUAL',
    /*
    Из справочника методик расчёта
     */
    BOOK = 'BOOK',
}

export const tableEmptyDataText = 'Для отображения данных добавьте лимитированные затраты';

export const enum TabsIds {
    COMMON = 'COMMON',
    PERCENT = 'PERCENT',
    FORMULA = 'FORMULA',
}

export type ChapterItem = { id: ChapterEnum; label: string };
export type TabItem = { id: TabsIds; label: string };

export const tabsItems = [
    { id: TabsIds.COMMON, label: 'Общие данные' },
    { id: TabsIds.PERCENT, label: 'Процент' },
    { id: TabsIds.FORMULA, label: 'Формула' },
];

export const invisibleStyle: React.CSSProperties = {
    visibility: 'hidden',
    position: 'absolute',
    overflow: 'hidden',
    maxHeight: 0,
};

export const CHAPTER_ITEMS = [
    {
        id: ChapterEnum.Chapter9,
        label: CHAPTER_RECORDS[ChapterEnum.Chapter9],
    },
    {
        id: ChapterEnum.Chapter8,
        label: CHAPTER_RECORDS[ChapterEnum.Chapter8],
    },
    {
        id: ChapterEnum.Chapter1_7,
        label: CHAPTER_RECORDS[ChapterEnum.Chapter1_7],
    },
];
